<template>
  <div class="container">
    <div class="left" v-if="!noPrepareData">
      <div class="list">
        <div class="item" v-for="(item, index) in list" :key="index">
          <Drag
            :key="item.resType"
            :list="item.resList"
            :type="item.resType"
            @prepareDel="prepareDel"
            :title="item.resTypeName"
            @prepareMove="prepareMove"
            v-if="item.resList && item.resList.length > 0"
          />
        </div>
      </div>
      <div class="bottom">
        <div @click="save">
          <img src="@/assets/icons/icon_bc.png" alt="" srcset="" />
          <span>保存</span>
        </div>
        <div @click="clear">
          <img src="@/assets/icons/icon_qk.png" alt="" srcset="" />
          <span>清空</span>
        </div>
      </div>
    </div>
    <div class="left nodata" v-else>
      <img src="@/assets/img/bj_bk_nodata.png" alt="" srcset="" />
      <div class="placeholder">
        <p>请选择右侧资源</p>
        <p>加入备课栏中</p>
      </div>
    </div>
    <div class="right">
      <template v-if="!isDeatil">
        <div class="back" @click="backVisible = true">
          <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
          <span>返回</span>
        </div>
        <div class="tabs">
          <div class="tab-name" :class="tabKey === 1 ? 'selected' : ''" @click="handleTypeChange(1)">校本资源</div>
          <div class="tab-name" :class="tabKey === 3 ? 'selected' : ''" @click="handleTypeChange(3)">个人资源</div>
          <div class="tab-name" :class="tabKey === 2 ? 'selected' : ''" @click="handleTypeChange(2)">研创资源</div>
        </div>
        <Selection :className="['flexEnd']" ref="selection" class="selection" @handleChange="handleChange" v-show="!(respagination.total == 0 && tabKey === 3 && !selected.keyword && !selected.resType)" />
        <div class="content" :class="tabKey === 2 ? 'lesson' : ''">
          <div class="res-list" v-if="respagination.total > 0">
            <div class="list">
              <div class="item" :key="item.id" v-for="item in reslist">
                <img
                  class="cover"
                  :src="item.cover"
                  @click="detail(item.id)"
                  :class="item.type === 'model' ? 'model' : ''"
                />
                <div :class="['title', tabKey === 3 ? 'personage' : '']" @click="detail(item.id)">{{ item.name || item.title }}</div>
                <div class="desc" v-if="item.Professions && item.Professions.length > 0">
                  <span v-for="(text, index) in item.Professions" :key="index">
                    {{ index === item.Professions.length - 1 ? text : text + '、' }}
                  </span>
                </div>
                <div class="desc" v-else-if="tabKey !== 2 && tabKey !== 3">无</div>
                <div v-if="!item.isAuth && tabKey !== 2" class="button-add authorizated">未授权</div>
                <div v-else-if="resourceChecked(item)" class="button-add checked" @click="massageAdd">已添加</div>
                <div v-else class="button-add" @click="prepareAdd(item)">加入备课</div>
                <span class="type" @click="detail(item.id)">{{ item.typeName }}</span>
              </div>
            </div>
            <Pagination
              class="list-pagination"
              :pagination.sync="respagination"
              @handleTableChange="handleTableChange"
            />
          </div>
          <template v-else>
            <Empty v-if="!!selected.keyword" :imgSrc="require('@/assets/img/bj_zanwu.png')" :isSearch="true"/>
            <MassUpload class="massUpload" @ok="onSearch()" v-else-if="tabKey === 3 && !selected.resType"></MassUpload>
            <Empty v-else :imgSrc="require('@/assets/img/bj_zanwu@2x.png')"/>
          </template>
        </div>
      </template>
      <div v-else>
        <Detail v-if="tabKey === 1" @back="isDeatil = false" :resourceId="resourceId" :resourceType="2"/>
        <Editor v-else-if="tabKey === 2" @back="() => {isDeatil = false; handleTypeChange(2)}" :id="resourceId"/>
        <Detail v-else @back="isDeatil = false" :resourceId="resourceId" :resourceType="3"/>
      </div>
    </div>
    
    <!-- <TipModal
      @ok="clear"
      :visible="clearVisible"
      :desc="`<p>确定要删除备课数据？</p><p class='placeholder'>备课数据删除后无法找回</p>`"
      @cancel="clearVisible = false" /> -->
    <TipModal
      @ok="save"
      :cancelText="'确定'"
      :okText="'保存备课信息'"
      :visible="backVisible"
      :desc="
        `
        <p></p>
        <p>确定要继续退出？</p>
        <p class='placeholder'>备课未保存，退出后备课数据不保存</p>`
      "
      @cancel="back(true)"
    />
  </div>
</template>
<script>
import { resTypeMap, resourceList, creatorLessonList, prepareLessonSave, prepareLessonDetail, getPersonResList } from '@/api/lesson'
import Drag from './drag.vue'
import Detail from '@/views/resourceDetails/index.vue'
import Editor from './editor.vue'
import Empty from '@/components/Empty/index.vue'
import TipModal from '@/components/tipModal/index'
import Selection from './selection'
import Pagination from '@/components/pagination/index.vue'
import MassUpload from '@/views/resource/private/components/MassUpload.vue'

const reversedNameMap = {
  text: '文本类',
  image: '图片类',
  audio: '音频类',
  video: '视频类',
  model: '3D模型',
  software: '3D实训软件'
}
export default {
  components: {
    Drag,
    Detail,
    Editor,
    Empty,
    TipModal,
    Selection,
    Pagination,
    MassUpload
  },
  data() {
    return {
      tabKey: 1,
      id: undefined,
      resTypeList: [],
      backVisible: false,
      saveVisible: false,
      clearVisible: false,
      prepareName: undefined,
      selected: {
        isAuth: true,
        resType: undefined,
        keyword: undefined,
        profession: []
      },
      list: [
        {
          resType: 'model',
          resTypeName: '3D模型',
          resList: []
        },
        {
          resType: 'creator',
          resTypeName: '研创资源',
          resList: []
        },
        {
          resType: 'image',
          resTypeName: '图片类',
          resList: []
        },
        {
          resType: 'audio',
          resTypeName: '音频类',
          resList: []
        },
        {
          resType: 'video',
          resTypeName: '视频类',
          resList: []
        },
        {
          resType: 'text',
          resTypeName: '文本类',
          resList: []
        },
        {
          resType: 'software',
          resTypeName: '3D实训软件',
          resList: []
        }
      ],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        hideOnSinglePage: true
      },
      reslist: [],
      respagination: {
        page: 1,
        pageSize: 8,
        total: 0
      },
      isDeatil: false,
      isCourseware: false
    }
  },
  computed: {
    noPrepareData() {
      if (this.list.length === 0) return false
      const index = this.list.findIndex(item => {
        return item.resList && item.resList.length > 0
      })
      return index === -1
    }
  },
  methods: {
    onSearch() {
      this.$refs.selection.onSearch()
    },
    handleTableChange() {
      if (this.tabKey === 1) {
        this.getResList()
      } else if (this.tabKey === 2) {
        this.getLessonList()
      } else {
        this.getSchoolResLists()
      }
    },
    handleTypeChange(key) {
      this.$nextTick(() => {
        this.tabKey = key
        this.$refs.selection.handleTypeChange(key)
      })
    },
    handleChange(obj) {
      this.respagination.page = 1
      console.log('obj ----->', obj)
      this.selected = Object.assign(this.selected, {
        isAuth: obj.isAuth,
        resType: obj.resType,
        keyword: obj.keyword,
        profession: obj.profession
      })
      if (this.tabKey === 1) {
        this.getResList()
      } else if (this.tabKey === 2) {
        this.getLessonList()
      } else {
        this.getSchoolResLists()
      }
    },
    back(checked) {
      const hasdata = this.list.findIndex(item => {
        if (item.resList.length > 0) return item
      })
      console.log(hasdata, checked, hasdata > -1 && !checked)
      if (hasdata > -1 && !checked) {
        this.backVisible = true
        return
      }
      this.backVisible = false
      localStorage.removeItem('prepareData')
      this.$router.go(-1)
    },
    save() {
      this.saveVisible = true
      this.backVisible = false
    },
    saveOk() {
      if (!this.prepareName) {
        this.saveVisible = true
        this.backVisible = false
        this.$message.error('备课名称不可为空')
        return
      }
      const resInfo = []
      console.log('this.list ----->', this.list)
      this.list.forEach(item => {
        if (item.resList.length > 0) {
          const resList = item.resList.map(res => {
            return {
              id: res.id,
              sourceType: res.sourceType,
              order: res.order ? Number(res.order) : 0
            }
          })
          item.resList = resList
          console.log('resList ----->', resList)
          resInfo.push(item)
        }
      })
      console.log(' resInfo----->', resInfo)
      const data = {
        resInfo,
        id: this.id,
        name: this.prepareName
      }
      prepareLessonSave(data).then(res => {
        if (res.code != 200) return
        this.saveVisible = false
        this.$message.success('保存成功！')
        this.back(true)
      })
    },
    clear() {
      this.clearVisible = false
      this.list.forEach(item => {
        item.resList = []
      })
      const data = Object.assign(JSON.parse(localStorage.prepareData), {
        list: this.list
      })
      this.noPrepareData = true
      localStorage.setItem('prepareData', JSON.stringify(data))
    },
    resourceChecked(obj) {
      let checked = false
      this.list.forEach(item => {
        if (item.resTypeName.indexOf(obj.typeName) > -1) {
          item.resList.forEach(it => {
            if (it.id === obj.id) checked = true
          })
        }
      })
      return checked
    },
    prepareMove(obj) {
      console.log(obj)
      this.list.forEach(item => {
        if (item.resType === obj.type) {
          item.resList = [...obj.list]
        }
      })
      const data = Object.assign(JSON.parse(localStorage.prepareData), {
        list: this.list
      })
      localStorage.setItem('prepareData', JSON.stringify(data))
    },
    prepareDel(obj) {
      console.log(obj)
      this.list.forEach(item => {
        if (item.resType === obj.type) {
          item.resList.forEach((it, index) => {
            if (it.id === obj.id) {
              item.resList.splice(index, 1)
            }
          })
        }
      })
      const data = Object.assign(JSON.parse(localStorage.prepareData), {
        list: this.list
      })
      localStorage.setItem('prepareData', JSON.stringify(data))
    },
    massageAdd() {
      this.$message.success('该资源已加入备课中')
    },
    detail(id) {
      this.isDeatil = true
      this.resourceId = id
      if (this.tabKey === 1) {
        this.isCourseware = false
      } else {
        this.isCourseware = true
      }
    },
    dragEnd(el) {
      console.log(el)
    },
    prepareAdd(obj) {
      // this.noPrepareData = false
      this.list = this.list.map(item => {
        const objj = { ...item }
        if (item.resType === obj.type) {
          objj.resList.push(obj)
        }
        return objj
      })
      this.$forceUpdate()
      // const index = this.list.findIndex(item => {
      //   if (item.resType === obj.type) return item
      // })
      // if (index > -1) {
      // this.list[index].resList.push(obj)
      // this.$forceUpdate()
      // } else {
      //   const type = this.resTypeList.find(item => {
      //     return item.name === obj.typeName
      //   })
      //   const resInfo = {
      //     resType: type.id,
      //     resTypeName: type.name,
      //     resList: [obj]
      //   }
      //   this.list.push(resInfo)
      // }
      const data = {
        name: this.prepareName,
        list: this.list
      }
      // console.log(this.noPrepareData)
      if (localStorage.prepareData) {
        data.name = JSON.parse(localStorage.prepareData).name
      }
      localStorage.setItem('prepareData', JSON.stringify(data))
    },
    getPrepareLessonDetail() {
      prepareLessonDetail({
        id: this.id
      }).then(res => {
        if (res.code != 200) return
        this.list = this.list.map(item => {
          const data = { ...item }
          res.data.resInfo.forEach(obj => {
            if (data.resType == obj.resType) {
              data.resList = [...obj.resList]
            }
          })
          return data
        })
        this.prepareName = res.data.name
        localStorage.setItem('prepareData', JSON.stringify({ name: this.prepareName, list: this.list }))
      })
    },
    getResList() {
      const data = Object.assign(this.selected, {
        appendFile: false,
        page: this.respagination.page,
        pageSize: this.respagination.pageSize
      })
      return new Promise((resolve, reject) => {
        resourceList(data).then(res => {
          if (res.code !== 200) return
          this.reslist = res.data.list.map(item => ({
            ...item,
            sourceType: 'school'
          }))
          this.respagination.total = res.data.total
          resolve(res.data.total)
        })
      })
    },
    getLessonList() {
      this.reslist = []
      this.respagination.total = 0
      const data = {
        page: this.respagination.page,
        keyword: this.selected.keyword,
        pageSize: this.respagination.pageSize
      }
      creatorLessonList(data).then(res => {
        if (res.code != 200) return
        this.reslist = res.data.list.map(item => {
          return {
            ...item,
            type: 'creator',
            typeName: '研创资源'
          }
        })
        this.respagination.total = Number(res.data.total) || 0
      })
    },
    getResTypeMap() {
      resTypeMap().then(res => {
        this.resTypeList = res.data.list
      })
    },
    getSchoolResLists() {
      const params = {
        type: this.selected.resType,
        name: this.selected.keyword,
        page: this.respagination.page,
        pageSize: this.respagination.pageSize
      }
      getPersonResList(params).then(res => {
        if (res.code != 200) return
        this.reslist = res.data.list.map(item => ({
          ...item,
          isAuth: true,
          sourceType: 'self',
          typeName: reversedNameMap[item.type]
        }))
        this.respagination.total = res.data.total
        this.setResourceCover()
      })
    },
    setResourceCover() {
      this.reslist.forEach(item => {
        if (item.cover) return
        switch (item.type) {
          case 'text':
            item.cover = require('@/assets/img/bg_text_cover.png')
            break
          case 'audio':
            item.cover = require('@/assets/img/bg_auido_cover.png')
            break
          case 'model':
            item.cover = require('@/assets/img/bj_mx@2x.png')
            break
          case 'software':
            item.cover = require('@/assets/img/bj_sx@2x.png')
            break
        }
      })
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      switch (vm.tabKey) {
        case 1:
        (async function () {
            const total = await vm.getResList()
            if (Number(total) === 0) {
              vm.selected.isAuth = false
              vm.$refs.selection.selected.isAuth = false
              vm.getResList()
            }
          })()
          break
        case 2:
          vm.getLessonList()
          break
        default:
          vm.getSchoolResLists()
      }
      vm.tabKey === 1 ? vm.getResList() : vm.tabKey === 2 ? vm.getLessonList() : vm.getSchoolResLists()
      vm.getResTypeMap()
      vm.id = Number(vm.$route.query.id) || 0
      const prepareData = localStorage.prepareData
      if (prepareData) {
        vm.prepareName = JSON.parse(localStorage.prepareData).name || undefined
        const oldPreparList = JSON.parse(localStorage.prepareData).list
        vm.list = [...oldPreparList]
      } else {
        if (vm.id > 0) {
          vm.getPrepareLessonDetail()
        } else {
          vm.list.forEach(item => {
            item.resList = []
          })
          vm.noPrepareData = true
          vm.prepareName = undefined
        }
      }
    })
  },
  activated() {
    this.isDeatil = false
    this.isCourseware = false
    this.selected.isAuth = true
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  display: flex;
  position: relative;
  .left {
    left: 0;
    height: 100%;
    width: 264px;
    position: absolute;
    padding: 0 11px 50px;
    // border: 1px solid #ccc;
    .list {
      width: 100%;
      height: 100%;
      color: #000;
      display: flex;
      padding: 20px 0 0;
      overflow-y: scroll;
      flex-direction: column;
    }
    .bottom {
      left: 230px;
      width: 264px;
      // height: 50px;
      bottom: 18px;
      display: flex;
      position: fixed;
      padding: 0 20px;
      align-items: center;
      justify-content: space-between;
      > div {
        width: 80px;
        height: 34px;
        display: flex;
        cursor: pointer;
        margin-right: 12px;
        border-radius: 4px;
        align-items: center;
        justify-content: center;
        border: 1.8px solid #d6d6d6;
        img {
          width: 13px;
          // height: 16px;
          cursor: pointer;
          margin-right: 9px;
        }
        span {
          font-size: 14px;
          font-weight: 400;
          color: #000000;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
  .left.nodata {
    img {
      width: 100%;
    }
    .placeholder {
      margin-top: 19px;
      p {
        font-size: 14px;
        font-weight: 800;
        color: #7c7c7c;
        line-height: 22px;
        text-align: center;
        margin: 0;
      }
    }
  }
  .right {
    padding: 20px 26px;
    margin-left: 264px;
    position: relative;
    width: calc(100% - 264px);
    background: url('./../../../assets/img/bj_y.png');
    background-size: 100% 100%;
    background-position: center;
    // overflow: hidden;
    .back {
      width: 80px;
      height: 34px;
      display: flex;
      cursor: pointer;
      font-size: 14px;
      font-weight: 400;
      color: #000000;
      margin-bottom: 18px;
      border-radius: 25px;
      align-items: center;
      justify-content: center;
      border: 1px solid #d6d6d6;
      img {
        height: 10px;
        margin-right: 9px;
      }
    }
    .tabs {
      height: 35px;
      display: flex;
      position: absolute;
      border-radius: 20px;
      background: #edf3fa;
      .tab-name {
        height: 100%;
        cursor: pointer;
        padding: 0 32px;
        color: #6b738c;
        font-size: 14px;
        line-height: 35px;
        border-radius: 20px;
      }
      .tab-name.selected {
        color: #fff;
        background: #f27529;
      }
    }
    .content {
      width: 100%;
      height: calc(100% - 125px);
      padding: 10px 0;
      .total {
        display: flex;
        margin-bottom: 19px;
        justify-content: space-between;
        > span {
          color: #687f9c;
        }
      }
      .res-list {
        height: 100%;
        padding: 10px 0 40px;
        position: relative;
        .list {
          width: 100%;
          display: flex;
          padding: 10px;
          flex-wrap: wrap;
          max-height: 100%;
          overflow-y: scroll;
          .item {
            display: flex;
            margin-top: 30px;
            margin-right: 20px;
            position: relative;
            border-radius: 6px;
            flex-direction: column;
            width: calc((100% - 60px) / 4);
            .cover {
              width: 100%;
              height: 190px;
              cursor: pointer;
              margin-bottom: 6px;
              border-radius: 6px;
            }
            .cover.model {
              border-radius: 6px;
              background: url('./../../../assets/img/bj_model.png') no-repeat;
              background-size: 100% 100%;
              background-position: center;
            }
            .type {
              left: 0;
              top: 8px;
              width: 70px;
              height: 23px;
              cursor: pointer;
              font-size: 11px;
              font-weight: 400;
              color: #28383b;
              line-height: 23px;
              text-align: center;
              position: absolute;
              border-radius: 0px 4px 4px 0px;
              background: linear-gradient(224deg, #eceff0 0%, #c6c9cd 100%);
            }
            .title {
              width: 100%;
              color: #000;
              font-size: 15px;
              cursor: pointer;
              overflow: hidden;
              font-weight: 550;
              line-height: 20px;
              margin-bottom: 6px;
              position: relative;
              white-space: nowrap;
              text-overflow: ellipsis;
              padding: 6px 0 9px 12px;
              &::after {
                bottom: 0;
                left: 12px;
                content: '';
                width: 21px;
                height: 3px;
                opacity: 0.6;
                position: absolute;
                border-radius: 2px;
                background: #ef623d;
                box-shadow: 0px 0px 10px -2px rgba(133, 133, 133, 0.66);
              }
            }
            .personage {
              margin-bottom: 0px;
              &::after {
                display: none;
              }
            }
            .desc {
              width: 100%;
              height: 20px;
              font-size: 12px;
              cursor: pointer;
              overflow: hidden;
              font-weight: 400;
              color: #000000;
              line-height: 19px;
              padding-left: 12px;
              margin-bottom: 6px;
              position: relative;
              white-space: nowrap;
              text-overflow: ellipsis;
            }
            .button-add {
              width: 90px;
              height: 27px;
              font-size: 14px;
              cursor: pointer;
              font-weight: 400;
              color: #ffffff;
              line-height: 27px;
              padding: 0 14px;
              margin-left: 12px;
              margin-bottom: 12px;
              border-radius: 6px;
              text-align: center;
              border-radius: 6px;
              display: inline-block;
              box-shadow: 0px 0px 3px 0px rgba(204, 76, 26, 0.12);
              background: linear-gradient(248deg, #ff6d00 0%, #f58623 100%);
            }
            .button-add.authorizated {
              width: 70px;
              background: linear-gradient(227deg, #72899d 0%, #9bb3c8 100%);
            }
            .button-add.checked {
              width: 70px;
              color: #75767a;
              box-shadow: none;
              background: #e9e9e9;
            }
            &:nth-child(4n) {
              margin-right: 0;
            }
            &:nth-child(-n + 4) {
              margin-top: 0;
            }
          }
          .item:hover .title {
            color: #ff6d00;
          }
        }
        .list-pagination {
          width: 100%;
          bottom: 30px;
          position: absolute;
        }
      }
      .no-data {
        height: 100%;
      }
      /deep/ .massUpload{
        width: 80%;
        height: 100%;
        padding-top: 10%;
        margin: 0 auto;
        .upload{
          height: 317px;
        }
      }
    }
    .content.lesson {
      height: calc(100% - 75px);
    }
    .container {
      padding-right: 0px;
      padding-left: 0px;
    }
  }
}
.button {
  cursor: pointer;
}

/deep/.ant-input {
  color: #000;
}
.ant-input-search {
  width: 300px;
  margin-bottom: 20px;
}
.list::-webkit-scrollbar {
  display: none;
}
/deep/.ant-modal {
  .ant-modal-body {
    font-size: 14px;
    color: #000;
    > div {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 10px;
      justify-content: center;
      &:first-child {
        font-size: 16px;
        font-weight: 550;
      }
    }
    .button {
      padding: 0 50px;
      span {
        width: 120px;
        padding: 5px 0;
        border-radius: 5px;
        text-align: center;
        border: 1px solid #ccc;
        &:first-child {
          margin-right: 50px;
        }
      }
    }
    > span:first-child {
      color: red;
      margin-right: 6px;
    }
    .ant-input-affix-wrapper {
      // width: 300px;
      margin-top: 9px;
    }
  }
  .ant-modal-footer {
    text-align: center;
    .ant-btn-primary {
      margin-left: 50px;
    }
  }
}
@media screen and(min-width: 1700px) and (max-width: 1900px) {
  .container {
    .left {
      width: 240px;
      .bottom {
        left: 210px;
        width: 240px;
      }
    }
    .right {
      margin-left: 240px;
      width: calc(100% - 240px);
      .content {
        .list {
          .item {
            .cover {
              height: 168px !important;
            }
          }
        }
      }
    }
  }
}
@media screen and(min-width: 1500px) and (max-width: 1700px) {
  .container {
    .left {
      width: 198px;
      .bottom {
        width: 198px;
        left: 170px;
      }
    }
    .right {
      margin-left: 198px;
      width: calc(100% - 198px);
      .content {
        .list {
          .item {
            .cover {
              height: 143px !important;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1400px) and (max-width: 1500px) {
  .container {
    .left {
      width: 198px;
      .bottom {
        width: 198px;
        left: 170px;
      }
    }
    .right {
      margin-left: 198px;
      width: calc(100% - 198px);
      .content {
        .list {
          .item {
            .cover {
              height: 127px !important;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1300px) and (max-width: 1400px) {
  .container {
    .left {
      width: 176px;
      .bottom {
        left: 153px;
        width: 176px;
      }
    }
    .right {
      margin-left: 176px;
      width: calc(100% - 176px);
      .content {
        .list {
          .item {
            .cover {
              height: 117px !important;
            }
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1200px) and (max-width: 1300px) {
  .container {
    .left {
      width: 176px;
      .bottom {
        left: 153px;
        width: 176px;
      }
    }
    .right {
      margin-left: 176px;
      width: calc(100% - 176px);
      .content {
        .list {
          .item {
            .cover {
              height: 112px !important;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .container {
    .left {
      width: 150px;
      .bottom {
        left: 130px;
        width: 150px;
      }
    }
    .right {
      margin-left: 150px;
      width: calc(100% - 150px);
      .content {
        .list {
          .item {
            .cover {
              max-height: 98px !important;
            }
          }
        }
      }
    }
  }
}
</style>
